import { useMemo } from 'react'
import { SeoPageSchema } from 'cms/schemaTypes/generalSchemas/seo'
import { SectionWithImagePageSchema } from 'cms/schemaTypes/staticPages/documents/sectionWithImage'

import { urlFor } from 'lib/sanity/image'
import Breadcrumbs from 'shared/ui/Breadcrumbs'
import { PATHS } from 'shared/utils/paths'

import {
  BannerImage,
  SectionContainer,
  SectionContent
} from '../landings/styles'
import MetaHeadCMS from '../MetaCMS'

import DeliveryInfoMenuItemsList from './DeliveryInfoMenuItemsList'

import styles from './DeliveryLayout.module.scss'

interface DeliveryLayoutProps {
  tabs: string[]
  seo: Omit<SeoPageSchema, '_type'>
  path: string
  banners: {
    desktop: SectionWithImagePageSchema
    mobile: SectionWithImagePageSchema
  }
  children: React.ReactNode
}
export const DeliveryLayout = ({
  tabs,
  seo,
  banners,
  children,
  path
}: DeliveryLayoutProps) => {
  const navigation = useMemo(() => {
    const paths = [
      PATHS.deliveryArea,
      PATHS.deliveryTime,
      PATHS.deliveryCost,
      PATHS.paymentMethods
    ]

    return paths.map((pathItem, index) => ({
      path: pathItem,
      label: tabs[index]
    }))
  }, [tabs])

  const breadcrumbs = useMemo(() => {
    const activePage = navigation.find(tab => tab.path === path)

    return [
      { label: 'Strona główna', path: PATHS.home },
      { label: 'Informacje o dostawie', path: PATHS.deliveryArea },
      { label: activePage?.label || '', path: activePage?.path || '' }
    ]
  }, [navigation, path])

  return (
    <>
      <SectionContainer as='div'>
        <MetaHeadCMS seo={seo} path={path} />
        <div>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <div className={styles.desktopContent}>
            <BannerImage
              src={urlFor(banners.desktop.image.asset.asset).url()}
              alt={banners.desktop.image.alt}
              width={1920}
              height={530}
              quality={100}
            />
          </div>
          <div className={styles.tabletContent}>
            <BannerImage
              src={urlFor(banners.mobile.image.asset.asset).url()}
              alt={banners.mobile.image.alt}
              width={1080}
              height={540}
              quality={100}
            />
          </div>
          <SectionContent $top={3} $topMobile={3} $bottom={0} $bottomMobile={0}>
            <DeliveryInfoMenuItemsList />
          </SectionContent>
        </div>
      </SectionContainer>
      <div className={styles.wrapper}>
        <div className={styles.contentWrapper}>{children}</div>
      </div>
    </>
  )
}
